import { Dialog, DialogContent, DialogTitle, Stack } from "@mui/material";
import React, { ReactElement, useState } from "react";

interface PopUpBoxProps {
  button: ReactElement;
  children: ReactElement;
  heading?: string;
  width?: string;
  height?: string;
  maxHeight?: string;
  minHeight?: string;
  onClose?: () => void;
  onBeforeClose?: () => boolean;
  closePopUp?: boolean;
  setClosePopUp?: (value: boolean) => void;
  showWarning?: boolean;
  sx?: any;
}

export default function PopUpBox({
  button,
  children,
  heading,
  width,
  height,
  maxHeight,
  minHeight,
  onClose,
  onBeforeClose,
  closePopUp,
  setClosePopUp,
  sx,
}: PopUpBoxProps) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    // Check if the button is disabled before opening
    if (button.props?.disabled) {
      return;
    }
    setOpen(true);
  };

  const handleClose = () => {
    if (onBeforeClose && !onBeforeClose()) {
      return;
    }
    setOpen(false);
    if (onClose) onClose();
    if (setClosePopUp) setClosePopUp(false);
  };

  // Effect to handle external close trigger
  React.useEffect(() => {
    if (closePopUp && open) {
      setOpen(false);
      if (onClose) onClose();
      if (setClosePopUp) setClosePopUp(false);
    }
  }, [closePopUp, open, onClose, setClosePopUp]);

  return (
    <>
      <Stack onClick={handleOpen}>{button}</Stack>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={width ? false : "md"}
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            ...(width && { width }),
            ...(height && { height }),
            ...(maxHeight && { maxHeight }),
            ...(minHeight && { minHeight }),
            borderRadius: 0,
            backgroundColor: "#ffffff",
            boxShadow: "none",
          },
          ...sx,
        }}
      >
        {heading && (
          <DialogTitle
            sx={{
              fontSize: "1.25rem",
              fontWeight: 500,
              // borderBottom: "1px solid #e0e0e0",
              paddingBottom: "1rem",
            }}
          >
            {heading}
          </DialogTitle>
        )}
        <DialogContent
          sx={{
            padding: "1rem",
            overflowX: "hidden",
            overflowY: "auto",
          }}
        >
          {children}
        </DialogContent>
      </Dialog>
    </>
  );
}
